import { getSchedulerDataServicesInstall } from "../services";
import { filteredServicesComponents } from "../filteredServicesComponent"

export function plumbingInstallation (){
  
  let servicesStart = [
  {
    id: "Water Heaters",
    label: <>Water Heaters</>,
    data: [
      [
        {
          name: "equipmentType",
          question: "What kind of water heater do you have?",
          answers: [
            {
              id: "Regular Tank",
              label: <>Regular Tank</>,
              value: "Water Heater",
              jobType: "Water Heater: Non-Member",
              remType: "estimate"
            },
            {
              id: "Tankless",
              label: <>Tankless</>,
              value: "Tankless Water Heater",
              jobType: "Tankless Water Heater: Non-Member",
              remType: "estimate"
            },
          ],
        },
        {
          name: "equipmentAge",
          question: "How old is your equipment?",
          answers: [
            {
              id: "0-5 Years",
              label: <>0-5 Years</>,
              value: "0-5 Years",
            },
            {
              id: "6-10 Years",
              label: <>6-10 Years</>,
              value: "6-10 Years",
            },
            {
              id: "11+ Years",
              label: <>11+ Years</>,
              value: "11+ Years",
            },
            {
              id: "Not Sure",
              label: <>Not Sure</>,
              value: "Not Sure",
            },
          ],
        },
      ],
      [
        {
          name: "How-soon-to-installed",
          question: "How soon are you looking to have new equipment installed?",
          answers: [
            {
              id: "This week",
              label: <>This week</>,
              value: "This week",
            },
            {
              id: "Within 30 Days",
              label: <>Within 30 Days</>,
              value: "Within 30 Days",
            },
            {
              id: "Unsure",
              label: <>Unsure</>,
              value: "Unsure",
            },
          ],
        },
      ],
    ],
  },
  {
    id: "Septic System",
    label: <>Septic System</>,
    jobType: "Septic System",
    remType: "estimate",
    data: [],
  },

  {
    id: "Basement Drainage",
    label: <>Basement Drainage</>,
    jobType: "Basement Drainage Channels",
    remType: "estimate",
    data: [],
  },
  {
    id: "Main Sewer Line",
    label: <>Main Sewer Line</>,
    jobType: "Sewer Main",
    remType: "estimate",
    data: [],
  },

  {
    id: "Fixtures & Bathroom",
    label: <>Fixtures & Bathroom</>,
    data: [
      [
        {
          name: "fixturesBathroom",
          question: "Fixtures & Bathroom",
          answers: [
            {
              id: "Faucet",
              label: <>Faucet</>,
              value: "Faucet",
              jobType: "Faucets, Fixtures and Pipes",
              remType: "estimate"
            },
            {
              id: "Garbage Disposal",
              label: <>Garbage Disposal</>,
              value: "Garbage Disposal",
              jobType: "Garbage Disposal",
              remType: "estimate"
            },
            {
              id: "Bathtub",
              label: <>Bathtub</>,
              value: "Bathtub",
              hiddenQuestionData: [
                {
                  name: "bathtub",
                  question: "Bathtub",
                  answers: [
                    {
                      id: "Standard",
                      label: <>Standard</>,
                      value: "Standard",
                      jobType: "Bathtub",
                      remType: "estimate"
                    },
                    {
                      id: "Walk-In",
                      label: <>Walk-In</>,
                      value: "Walk-In",
                      jobType: "Walk In Bathtub",
                      remType: "estimate"
                    },
                  ],
                },
              ],
            },
            {
              id: "Shower",
              label: <>Shower</>,
              value: "Shower",
              jobType: "Shower",
              remType: "estimate"
            },
          ],
        },
      ],
    ],
  },
  {
    id: "Water/Fuel Tank",
    label: <>Water/Fuel Tank</>,
    jobType: "Water or Fuel Tank",
    remType: "estimate",
    data: [],
  },
  {
    id: "Sump Pump",
    label: <>Sump Pump</>,
    jobType: "Sump Pump",
    remType: "estimate",
    data: [],
  },
  {
    id: "Water Main",
    label: <>Water Main</>,
    jobType: "Water Main",
    remType: "estimate",
    data: [],
  },
  {
    id: "Well Pump",
    label: <>Well Pump</>,
    jobType: "Well Pump",
    remType: "estimate",
    data: [],
  },
  {
    id: "Backflow Prevention",
    label: <>Backflow Prevention</>,
    jobType: "Backflow Prevention",
    remType: "estimate",
    data: [],
  },
  {
    id: "Water Purification",
    label: <>Water Purification</>,
    jobType: "Water Treatment & Purification System",
    remType: "estimate",
    data: [],
  },
  {
    id: "Remodel Estimate",
    label: <>Remodel Estimate</>,
    jobType: "Plumbing for a Home Addition or Remodel",
    remType: "estimate",
    data: [],
  },
];

const jobTypeFilter = getSchedulerDataServicesInstall// Replace with the desired job type to filter

return filteredServicesComponents(servicesStart, jobTypeFilter);
}